var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavCatalog2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.975,
    height: 18.794,
    viewBox: "0 0 15.975 18.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b1b1c9",
    d: "M16.305 10a.487.487 0 0 0-.426.47v.23h-1.453a.487.487 0 0 0-.426.47v17.154a.488.488 0 0 0 .47.47h14.1a.488.488 0 0 0 .47-.47v-1.41h.47a.488.488 0 0 0 .47-.47V10.47a.488.488 0 0 0-.48-.47h-9.18c-.248 0 0 .222 0 .47s-1.4.473-1.156.47h9.867v15.035H16.819V10.94h5.168a.47.47 0 1 0 0-.94zm-1.365 1.644h.94v14.8a.488.488 0 0 0 .47.47H28.1v.94H14.94zm4.185 2.819a.47.47 0 1 0 .044.94h7.048a.47.47 0 1 0 0-.94zm0 2.349a.47.47 0 1 0 .044.94h7.048a.47.47 0 1 0 0-.94zM21 19.162a.47.47 0 1 0 .044.94h5.168a.47.47 0 1 0 0-.94zm-1.879 2.349a.47.47 0 1 0 .044.94h7.048a.47.47 0 1 0 0-.94z",
    transform: "translate(-14 -10) translate(14 10) translate(-14 -10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCatalog2);
export default __webpack_public_path__ + "static/media/nav-catalog-2.869c4bf361b60e01c51b82fbe12e15be.svg";
export { ForwardRef as ReactComponent };